module.exports = __webpack_public_path__ + "img/favicon.81c8692c.svg";